import { useState } from "react";
import classNames from "classnames";
import { Card, CardBody, CardHeader, CardSubtitle, CardTitle, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import { TNullable } from "../../../../common/types/common";
import Chart from "../chart";
import "./styles.scss";
import { TWorkSession } from "src/common/types";

interface TabsProps {
    data: TNullable<TWorkSession> | undefined;
}

const Tabs = ({ data }: TabsProps) => {
    const [activeTab, setActiveTab] = useState<number>(1);
    const navItemCommonClass = "p-2 fs-5";

    return (
        <Card>
            <Nav tabs>
                <NavItem className={classNames(navItemCommonClass, { 'active text-primary': activeTab === 1})}>
                    <NavLink onClick={() => setActiveTab(1)}>
                        GENERAL DATA
                    </NavLink>
                </NavItem>
                <NavItem className={classNames(navItemCommonClass, { 'active text-primary': activeTab === 2})}>
                    <NavLink onClick={() => setActiveTab(2)}>
                        ERRORS
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent
                activeTab={activeTab}
                className="p-3"
            >
                <TabPane tabId={1}>
                    <Row className="pt-4">
                        <Col xl={4}>
                            <Card>
                                <CardHeader>
                                    <CardTitle tag="h5" style={{ fontWeight: 'bold' }}>MULCHER HP</CardTitle>
                                    <CardSubtitle style={{ color: '#9ca3af', fontWeight: 600 }}>LAST 1 HOUR MAXIMUM</CardSubtitle>
                                </CardHeader>
                                <CardBody>
                                    <Chart 
                                        chartData={data?.powerData || []} 
                                        title="Maximum: Power (Horsepower)" 
                                        borderColor="rgb(239, 68, 68)" 
                                        backgroundColor="rgba(239, 68, 68, 0.3)" 
                                        pointBackgroundColor="rgb(239, 68, 68)" 
                                        pointBorderColor="rgb(0, 0, 0)" 
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xl={4}>
                            <Card>
                                <CardHeader>
                                    <CardTitle tag="h5" style={{ fontWeight: 'bold' }}>MULCHER ROTOR RPM</CardTitle>
                                    <CardSubtitle style={{ color: '#9ca3af', fontWeight: 600 }}>LAST 1 HOUR MAXIMUM</CardSubtitle>
                                </CardHeader>
                                <CardBody>
                                    <Chart 
                                        chartData={data?.rotorSpeedData || []} 
                                        title="Maximum: Tool Speed (RPM)"
                                        borderColor="rgb(16, 185, 129)"
                                        backgroundColor="rgba(16, 185, 129, 0.3)"
                                        pointBackgroundColor="rgb(16, 185, 129)"
                                        pointBorderColor="rgb(0, 0, 0)"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xl={4}>
                            <Card>
                                <CardHeader>
                                    <CardTitle tag="h5" style={{ fontWeight: 'bold' }}>MULCHER PRESSURE PSI</CardTitle>
                                    <CardSubtitle style={{ color: '#9ca3af', fontWeight: 600 }}>LAST 1 HOUR AVERAGE</CardSubtitle>
                                </CardHeader>
                                <CardBody>
                                    <Chart 
                                        chartData={data?.pressureData || []} 
                                        title="Average: Motor Pressure (PSI)"
                                        borderColor="rgb(249, 115, 22)"
                                        backgroundColor="rgba(249, 115, 22, 0.3)"
                                        pointBackgroundColor="rgb(249, 115, 22)"
                                        pointBorderColor="rgb(0, 0, 0)"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId={2}>
                    {data?.errors && data?.errors.length > 0 ? (
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Error #</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(
                                    (data?.errors || []).reduce<Record<string, { message: string }>>(
                                        (acc, err) => {
                                            if (!acc[err.name]) {
                                                acc[err.name] = { message: err.message };
                                            }
                                            return acc;
                                        }, {}
                                    )
                                )
                                .sort(([a], [b]) => a.localeCompare(b))
                                .map(([errorName, { message }]) => (
                                    <tr key={errorName}>
                                        <td>{errorName}</td>
                                        <td>{message}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <span>No errors recorded</span>
                    )}
                </TabPane>
            </TabContent>
        </Card>
    );
};

export default Tabs;
